import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { db, storage } from "../../firebase";
import { collection, addDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

import "../../admin/AdminDashboard.css";

const GOOGLE_API_KEY = "AIzaSyA93FPo9uPGHk0g8FFvaZSKokn4n1tLmag";

export default function AddClue() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [hint, setHint] = useState("");
  const [helpfultip, setHelpfulTip] = useState("");
  const [order, setOrder] = useState(1);
  const [imageURL, setImageURL] = useState("");
  const [nextLocation, setNextLocation] = useState("");

  const [uploading, setUploading] = useState(false);
  const [saving, setSaving] = useState(false);

  function buildMapEmbed(location) {
    if (!location) return null;
    const trimmed = location.trim();
    if (/^-?\d+(\.\d+)?\s*,\s*-?\d+(\.\d+)?$/.test(trimmed)) {
      const [lat, lng] = trimmed.split(",");
      return `https://www.google.com/maps/embed/v1/view?key=${GOOGLE_API_KEY}&center=${lat.trim()},${lng.trim()}&zoom=16`;
    }
    return null;
  }

  const mapPreview = buildMapEmbed(nextLocation);

  async function uploadClueImage(e) {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);

    try {
      const storageRef = ref(storage, `clues/${id}/clue_${Date.now()}.jpg`);
      await uploadBytes(storageRef, file);
      const url = await getDownloadURL(storageRef);

      setImageURL(url);
      alert("Image uploaded!");
    } catch (err) {
      alert("Failed to upload image.");
    }

    setUploading(false);
  }

  async function saveClue(e) {
    e.preventDefault();
    setSaving(true);

    try {
      const clueData = {
        trailId: id,
        order: Number(order),
        question,
        answer,
        hint,
        imageURL: imageURL || "",
        nextlocation: nextLocation || ""
      };

      if (helpfultip.trim() !== "") {
        clueData.helpfultip = helpfultip.trim();
      }

      await addDoc(collection(db, "clues"), clueData);

      alert("Clue added!");
      navigate(`/admin/trails/${id}/clues`);

    } catch (err) {
      alert("Failed to save clue.");
    }

    setSaving(false);
  }

  return (
    <div className="dash-page">
      <div className="dash-container">
        <div style={{ marginBottom: "20px" }}>
          <button
            className="dash-btn secondary"
            onClick={() => navigate(`/admin/trails/${id}/clues`)}
            style={{ width: "auto" }}
          >
            ← Back to Clues
          </button>
        </div>

        <header className="dash-header">
          <div className="dash-header-content">
            <h1 className="dash-title">Add New Clue</h1>
            <p className="dash-subtitle">Create a new clue for this trail</p>
          </div>
        </header>

        <form className="admin-form-large" onSubmit={saveClue}>
          
          {/* CLUE IMAGE */}
          <div className="section-box">
            <h2 className="section-title">🖼️ Clue Image (Optional)</h2>

            {imageURL && (
              <div style={{ marginBottom: "20px" }}>
                <img
                  src={imageURL}
                  alt="Clue"
                  className="banner-preview"
                />
                <button
                  type="button"
                  className="dash-btn secondary"
                  onClick={() => {
                    if (window.confirm("Remove this image?")) {
                      setImageURL("");
                    }
                  }}
                  style={{ 
                    width: "auto",
                    background: "rgba(239, 68, 68, 0.1)",
                    borderColor: "rgba(239, 68, 68, 0.3)",
                    color: "var(--color-error)"
                  }}
                >
                  🗑 Remove Image
                </button>
              </div>
            )}

            <label className="admin-label">Upload Image</label>
            <input
              type="file"
              accept="image/*"
              onChange={uploadClueImage}
              className="admin-input"
            />
            {uploading && (
              <p style={{ color: "var(--color-accent)", marginTop: "8px" }}>
                Uploading…
              </p>
            )}
          </div>

          {/* CLUE ORDER */}
          <div className="section-box">
            <h2 className="section-title">🔢 Clue Order</h2>

            <label className="admin-label">Order Number</label>
            <input
              type="number"
              value={order}
              onChange={(e) => setOrder(e.target.value)}
              className="admin-input"
              style={{ maxWidth: "150px" }}
            />
          </div>

          {/* QUESTION & ANSWER */}
          <div className="section-box">
            <h2 className="section-title">❓ Question & Answer</h2>

            <label className="admin-label">Question *</label>
            <textarea
              value={question}
              onChange={(e) => setQuestion(e.target.value)}
              className="admin-input admin-textarea"
              rows="4"
              placeholder="Enter the clue question..."
              required
            />

            <label className="admin-label" style={{ marginTop: "16px" }}>Answer *</label>
            <input
              value={answer}
              onChange={(e) => setAnswer(e.target.value)}
              className="admin-input"
              placeholder="Enter the correct answer..."
              required
            />
          </div>

          {/* HINTS */}
          <div className="section-box">
            <h2 className="section-title">💡 Hints & Tips</h2>

            <label className="admin-label">Hint (Optional)</label>
            <textarea
              value={hint}
              onChange={(e) => setHint(e.target.value)}
              className="admin-input admin-textarea"
              rows="3"
              placeholder="A hint to help players who are stuck..."
            />

            <label className="admin-label" style={{ marginTop: "16px" }}>
              Helpful Tip / Fun Fact (Optional)
            </label>
            <p style={{ 
              fontSize: "0.85em", 
              color: "var(--color-text-secondary)", 
              marginTop: "-4px", 
              marginBottom: "8px" 
            }}>
              * This only shows when the clue is answered
            </p>
            <textarea
              value={helpfultip}
              onChange={(e) => setHelpfulTip(e.target.value)}
              className="admin-input admin-textarea"
              rows="3"
              placeholder="Optional helpful message or fun fact for players..."
            />
          </div>

          {/* NEXT LOCATION */}
          <div className="section-box">
            <h2 className="section-title">📍 Next Location</h2>

            <label className="admin-label">
              Coordinates (Optional)
              <span style={{ fontSize: "0.9em", color: "var(--color-text-secondary)", marginLeft: "8px" }}>
                Format: 53.2743872, -9.0518509
              </span>
            </label>
            <input
              value={nextLocation}
              onChange={(e) => setNextLocation(e.target.value)}
              className="admin-input"
              placeholder="53.2743872, -9.0518509"
              style={{ fontFamily: "'JetBrains Mono', monospace" }}
            />

            {mapPreview && (
              <div style={{ marginTop: "16px" }}>
                <p style={{ color: "var(--color-success)", fontSize: "0.9em", marginBottom: "12px" }}>
                  ✓ Valid coordinates
                </p>
                <iframe
                  title="Map Preview"
                  src={mapPreview}
                  allowFullScreen
                  loading="lazy"
                  style={{
                    width: "100%",
                    height: "320px",
                    border: "0",
                    borderRadius: "12px",
                    boxShadow: "var(--shadow-md)"
                  }}
                />
              </div>
            )}
          </div>

          {/* ACTION BUTTONS */}
          <div style={{ 
            display: "flex", 
            gap: "12px", 
            marginTop: "30px",
            paddingTop: "20px",
            borderTop: "2px solid var(--color-border)"
          }}>
            <button 
              type="submit"
              className="dash-btn primary" 
              disabled={saving}
              style={{ flex: 1 }}
            >
              {saving ? "Saving…" : "✨ Save Clue"}
            </button>

            <button
              type="button"
              className="dash-btn secondary"
              onClick={() => navigate(-1)}
              style={{ flex: 1 }}
            >
              Cancel
            </button>
          </div>

        </form>
      </div>
    </div>
  );
}